.container {
  /* A popover carries UA defaults — a border, padding, `inset: 0`, and
     `width: fit-content` — which would fight the positioning below. */
  border: none;
  padding: 0;
  margin: 0;
  overflow: visible;
  background: transparent;
  inset: auto;

  position: fixed;
  bottom: var(--space-5);
  right: var(--space-5);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  /* The stack itself must not block clicks on the page behind it. */
  pointer-events: none;
  max-width: min(90vw, 420px);
}

.toast {
  pointer-events: auto;   /* but the toasts themselves are interactive */
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-left-width: 3px;
  border-radius: var(--radius);
  box-shadow: var(--shadow-md);
  animation: slide-in var(--transition) ease-out;
}

@keyframes slide-in {
  from { opacity: 0; transform: translateX(16px); }
  to   { opacity: 1; transform: translateX(0); }
}

.success { border-left-color: var(--success); }
.error   { border-left-color: var(--danger); }
.info    { border-left-color: var(--info); }

.icon {
  flex-shrink: 0;
  font-size: var(--text-md);
  line-height: 1.4;
}

.success .icon { color: var(--success); }
.error   .icon { color: var(--danger); }
.info    .icon { color: var(--info); }

.message {
  flex: 1;
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
  color: var(--text);
  /* Server messages can be long; wrap rather than overflow. */
  overflow-wrap: anywhere;
}

.dismiss {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  font-size: 18px;
  line-height: 1;
  color: var(--text-subtle);
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
}

.dismiss:hover {
  background: var(--bg-hover);
  color: var(--text);
}

@media (max-width: 640px) {
  .container {
    left: var(--space-4);
    right: var(--space-4);
    bottom: var(--space-4);
    max-width: none;
  }
}
